import React from "react";
import "../css/PageHeader.css";

const PageHeader = () => {
  const bgImage = "/images/b.jpeg";
  return (
    <div
      className="page-header-container"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="header-overlay">
        <div className="header-content">
          <h1 className="header-title">
            SAHARA - VISION, MISSION & CORE VALUES
          </h1>
          <p className="header-subtitle">
            Our vision is to become a global role model for teaching and
            learning.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
